import { computed, inject } from 'vue';
import { IFileData } from '../types';
import { uploaderKey } from '../utils/token';
import { useAppStore } from '@/store/app';
import { SYSTEM_ENUM } from '@/core/http/env';

export default function useOssUlrSize() {
  const uploaderRef = inject(uploaderKey)!;
  const uploaderSize = computed(() => {
    return uploaderRef.size;
  });
  // 是否视频文件
  const videoTypes = ['mp4', 'webm', 'ogg', 'mov'];
  const isVideoType = (url: string) => {
    const _type = url?.split('.')?.pop()?.toLowerCase?.();
    return (_type && videoTypes.includes(_type)) || false;
  };
  // 是否图片文件
  const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
  const isImageType = (url: string) => {
    const _type = url?.split('.')?.pop()?.toLowerCase?.();
    return (_type && imageTypes.includes(_type)) || false;
  };
  const { systemDomain } = useAppStore();
  // 显示oss图片拆剪
  const ossUrl = (url?: string, w: string | number = '80') => {
    if (!url) return '';
    if (!/oss/.test(url)) return url;
    const isVideo = isVideoType(url);
    const isImage = isImageType(url);
    if (!isVideo && !isImage) return url;
    let queryStr = `x-oss-process=image/resize,w_${w},m_lfit&image_process=quality,q_95`;
    if (isVideo) {
      queryStr = `x-oss-process=video/snapshot,t_0,f_jpg,m_fast,w_${w}`;
    }
    if (url.includes('?')) {
      return `${url}&${queryStr}`;
    }
    return `${url}?${queryStr}`;
  };

  const getOssUrlSize = (item: IFileData, isFake?: boolean) => {
    const { url } = item;
    if (isFake === true) {
      return url;
    }
    const sizeNum = {
      small: 148 * 2,
      medium: 360 * 2,
      mini: 95 * 2,
      tiny: 52 * 2,
    };
    return ossUrl(url, sizeNum[uploaderSize.value]);
  };

  return {
    getOssUrlSize,
  };
}
